import { css } from '@emotion/react';

export const bannerBg = css({

    '@media(min-width: 300px)': {
        width: '100%',
        position: 'fixed',
        top: 0,
        zIndex: 2,
        fontFamily: 'AcuminRPro',
        backgroundColor: '#064E72',
        height: 40,
        alignContent: 'center',
    },

    '@media(min-width: 1200px)': {
        width: '100%',
        position: 'fixed',
        top: 0,
        zIndex: 2,
        fontFamily: 'AcuminRPro',
        backgroundColor: '#064E72',
        height: 50,
        alignContent: 'center',
    },

});

export const rightToLeft = css({

    '@media(min-width: 300px)': {
        // overflow: 'hidden',
        display: 'flex',
        minWidth: '100%',
        justifyContent: 'flex-end',
        animation: 'RightToLeft 15s infinite linear',

        '& p': {
            fontSize: '1.8rem',
            color: 'white',
            fontWeight: 500,
            margin: 0,
            whiteSpace: 'nowrap',
        },

        '@keyframes RightToLeft': {
            from: {
                transform: 'translateX(130%)',
            },
            to: {
                transform: 'translateX(-100%)',
            },
        },
    },

    '@media(min-width: 1200px)': {
        overflow: 'hidden',
        display: 'flex',
        minWidth: '100%',
        justifyContent: 'flex-end',
        animation: 'RightToLeft 25s infinite linear',

        '& p': {
            fontSize: '1.8rem',
            color: 'white',
            fontWeight: 500,
            margin: 0,
            whiteSpace: 'nowrap',
        },

        '@keyframes RightToLeft': {
            from: {
                transform: 'translateX(40%)',
            },
            to: {
                transform: 'translateX(-100%)',
            },
        },
    },

});
